import { HorizontalSeparator } from "./HorizontalSeparator";

export default HorizontalSeparator;
